<template>
  <DModal>
    <div class="d-modal" slot="insertComponent">
      <div class="d-modal__header">
        <h2><span v-if="editsms">{{ $t('vue2.sms.edit') }}</span><span v-else>{{ $t('vue2.sms.new') }}</span>
          {{ $t('vue2.sms.standard_sms') }}</h2>
        <div class="d-modal__close icon__bg-circle" @click="$emit('close')">
          <span class="icon-cross2"></span>
        </div>
      </div>
      <div class="d-modal__content">
        <div class="d-input-group">
          <label>{{ $t('vue2.sms.subject') }}</label>
          <input type="text" :class="{'input--error': errors.title}" v-model="title" @keyup="resetValidation('title')"
                 ref="titleInput" :placeholder="$t('vue2.sms.ex_you_are_sub')">
          <p class="input-error" v-if="errors.title">{{ errors.title }}</p>
        </div>
        <div class="d-input-group marg-10-top">
          <label>{{ $t('vue2.sms.message') }}</label>
          <textarea v-model="body" ref="smsbodyinput" @keyup="resetValidation('body')"
                    :class="{'input--error': errors.body}"></textarea>
          <p class="input-error" v-if="errors.body">{{ errors.body }}</p>
        </div>
        <button class="bttn--small marg-5-top" @click="insertToday">{{ today }}</button>
        <span class="d-desc link" @click="insertToday">{{ $t('vue2.sms.insert_today_to') }} "{{ today }}"</span>
      </div>
      <div class="d-modal__buttons pad-1">
        <button class="bttn bttn-simple marg-10-right" @click="$emit('close')">{{ $t('vue2.common.cancel') }}</button>
        <button v-if="editsms" class="bttn submit-button" @click="updateTemplate">{{
            $t('vue2.common.update')
          }}
        </button>
        <button v-else class="bttn submit-button" @click="submit">{{ $t('vue2.common.create') }}</button>
      </div>
    </div>
  </DModal>
</template>

<script>
import docendo from '../../docendo'
import DModal from '../common/DModal'
import autosize from 'autosize'
import eventbus from '../../eventbus'
import moment from 'moment'

export default {
  components: {DModal},
  props: {
    editsms: {
      type: Object
    },
    messageType: {
      default: 'sms'
    }
  },
  data () {
    return {
      title: '',
      body: '',
      errors: {}
    }
  },
  computed: {
    today () {
      moment.locale(window.USER.language)
      return moment().format('dddd')
    }
  },
  methods: {
    insertToday () {
      this.body = this.body + '[today]'
      this.$refs.smsbodyinput.focus()
    },
    validation () {
      if (this.title.length < 1) {
        this.$set(this.errors, 'title', this.$t('vue2.common.must_be_filled'))
      }
      if (this.body.length < 1) {
        this.$set(this.errors, 'body', this.$t('vue2.common.must_be_filled'))
      }
    },
    resetValidation (type) {
      this.$delete(this.errors, type)
    },
    updateTemplate () {
      this.validation()
      if (this.errors.length > 0) {
        return
      }
      docendo.updateMessageTemplate(window.SCHOOL.id, this.editsms.id, this.title, this.body, this.editsms.message_type, success => {
        eventbus.toast = {text: this.$t('vue2.sms.updated_sms_template'), success: true}
        this.$emit('updated')
      }, failure => {
        eventbus.toast = {text: this.$t('vue2.sms.an_error_occured'), success: false}
      })
    },
    submit () {
      this.validation()
      if (this.errors.length > 0) {
        return
      }
      let messageType = this.messageType === 'sms' ? 'sms' : 'email'
      docendo.createMessageTemplate(window.SCHOOL.id, this.title, this.body, messageType, success => {
        eventbus.toast = {text: this.$t('vue2.sms.created_sms_template'), success: true}
        this.$emit('updated')
      }, failure => {
        eventbus.toast = {text: this.$t('vue2.sms.an_error_occured'), success: false}
      })
    }
  },
  beforeMount () {
    if (this.editsms) {
      this.title = this.editsms.title
      this.body = this.editsms.body
    }
  },
  mounted () {
    autosize(document.querySelectorAll('textarea'))
    this.$refs.titleInput.focus()
  }
}
</script>

<style>
.d-modal {
  width: 350px;
  border-radius: 16px;
  position: relative;
}

.d-modal__header {
  padding: 1rem;
}

.d-modal__content {
  padding: 1rem;
}

.d-modal__close {
  position: absolute;
  top: 5px;
  right: 5px;
  font-size: 16px !important;
}

.d-modal__buttons {
  margin: 10px 0;
  display: flex;
  justify-content: flex-end;
}

.d-desc {
  font-size: 10px;
}

.d-input-group input, .d-input-group textarea {
  background: #ffffff;
}

.d-input-group input.input--error, .d-input-group textarea.input--error {
  border-color: #d72b3f;
}

.d-input-group .input-error {
  margin-top: 0;
}

.pad-1 {
  padding: 1rem;
}

.marg-5-top {
  margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// MessageTemplate.vue?124a10f7